export const serializeAuth = (auth) => ({
    userId: auth.user_id,
    email: auth.email,
    token: auth.token,
    refreshToken: auth.refresh_token,
    emailVerified: auth.email_verified
})
